import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_default_bank_stmt_import_file_helper_RowClass } from '../../../dbschema';

export class BankStatementImportFileHelperContainerModel extends BaseContainerModel {
    bl_fi_default_bank_stmt_import_file_helper: bl_fi_default_bank_stmt_import_file_helper_RowClass = new bl_fi_default_bank_stmt_import_file_helper_RowClass();
}